import React from 'react';
import ReactDOM from 'react-dom/client';
import { Amplify } from 'aws-amplify';
import App from './App.tsx';
import './index.css';
import { getAmplifyConfig } from './config/amplify.ts';
import { setRuntimeConfig } from './config/runtimeConfig.ts';

const isDevMode = import.meta.env.VITE_DEV_MODE === 'true';

async function init() {
  if (!isDevMode) {
    try {
      const res = await fetch('/config.json');
      if (res.ok) {
        setRuntimeConfig(await res.json());
      }
    } catch {
      console.warn('Could not load /config.json, falling back to environment variables');
    }
    Amplify.configure(getAmplifyConfig());
  }

  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

init();
